@if (enabled) {
  <button
    class="transparent-btn"
    (click)="contractModal.openModal()"
    ngbTooltip="Créer une police"
    i18n-ngbTooltip
  >
    <app-arrow-right-icon height="16px" width="16px" color="var(--brand-500)" />
  </button>
  <app-add-contract-modal
    #contractModal
    [custId]="userId"
    [centralisationId]="centralisationId"
    [insuranceType]="insuranceType"
    [insurer]="insurer"
    (policyAdded)="refreshTaskDetails()"
  />
}
